import { registerHandler } from "../handler";

declare let liQ: any;

// Owner: Ronnie (Affiliate)
export default function registerHandlers() {
  registerHandler("lead", ({ emailHashes }) => {
    (window as any).liQ = (window as any)?.liQ || [];
    liQ.push({
      event: "conversion",
      name: "email_signup",
      emailHash: emailHashes.md5,
    });
  });

  registerHandler("purchase", ({ plan, emailHashes, order }) => {
    const { price } = plan;
    (window as any).liQ = (window as any)?.liQ || [];
    liQ.push({
      event: "conversion",
      name: "product_purchase",
      emailHash: emailHashes.md5,
      conversionId: order.subscriptionId,
      amount: price,
      currency: plan.currency,
      items: [
        {
          id: plan.braintree_id,
          price,
          quantity: 1,
          currency: plan.currency,
        },
      ],
    });
  });
}
